import React, { useState, useEffect } from "react";
import NavBar from "../components/NavBar";
import Hero from "../components/Hero";
import Service from "../components/Service";
import Quote from "../components/Quote";
import Client from "../components/Client";
import About from "../components/About";
import HappyClient from "../components/HappyClient";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Mission from "../components/Mission";
import Partners from "../components/Partners";
import Values from "../components/Values";

const HomePage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      {loading ? (
        <>
          <div className="w-full h-screen flex justify-center items-center">
            <div className="flex">
              <div
                className="w-12 h-12 rounded-full animate-spin
                    border-y-4 border-solid border-[green-500] border-t-transparent"
              ></div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="bg-[#555A54] flex flex-col overflow-x-hidden">
            <NavBar />
            <Hero />
          </div>
          <About />
          <Mission />
          <Values/>
          <Service />
          <Client />
          <Partners />
          <HappyClient />
          <Contact />
          <Footer />
        </>
      )}
    </>
  );
};

export default HomePage;
